import { Injectable } from '@angular/core';
import { FeatureType } from 'src/app/models/EnumTypes';
import { NavaidDTOCalculation, NavaidModel, NavaidSitingToolModel } from 'src/app/models/navaid';
import { ModalControlService } from 'src/app/services/modal-control.service';
import { PointsService } from 'src/app/services/points.service';
import { SearchService } from 'src/app/services/search.service';
import { CalculationsService } from 'src/app/services/calculations.service';
import { ValidationModalService } from 'src/app/services/validation-modal.service';
import { ConfigurationService } from 'src/app/services/configuration.service';
import { UtilsService } from 'src/app/services/utils.service';
import { SitingToolService } from 'src/app/services/siting-tool-service.service';
import { PendingCalculation, PendingCalculationType } from 'src/app/models/pendingCalculation';
import { CalculationsControlService } from 'src/app/services/calculations-control.service';
import { Feature } from 'ol';
import { Geometry } from 'ol/geom';
import { MsalService } from '@azure/msal-angular';
import { CookieService } from 'ngx-cookie-service';
import { EndpointsService } from 'src/app/services/endpoints.service';
import { lastValueFrom } from 'rxjs';
import { b2cPolicies, msalConfig } from 'src/app/auth-config';

@Injectable({
  providedIn: 'root'
})
export class MenuManagementService {

  menuOptions = new Map();
  open : boolean = false;

  constructor(
    private searchService: SearchService,
    private authService: MsalService,
    public sitingToolService: SitingToolService,
    private readonly cookieService: CookieService) {
      this.menuOptions.set("user", false);
      this.menuOptions.set("configuration",false);
      this.menuOptions.set("import",false);
      this.menuOptions.set("export",false);
      this.menuOptions.set("view",false);
      this.menuOptions.set("database",false);
      this.menuOptions.set("calculation",false);
      this.menuOptions.set("tools",false);
      this.menuOptions.set("help",false);
      this.menuOptions.set("calculation-results",false);
      this.menuOptions.set("logout",false);
   }

  toogleMenu(option? : string){
    this.menuOptions.forEach((value: boolean, key: string) => {
      if(option != null && option != undefined && key == option){
        this.menuOptions[key] = !this.menuOptions[key];
        return;
      }
      if (option != "calculation-results" && key != "calculation-results"){
        this.menuOptions[key] = false;
      }
   });
   if(option == undefined){
    this.open = false;
   }
   this.searchService.expanded = true;
  }

  closeAllMenus(){
    this.menuOptions.forEach((value: boolean, key: string) => {
      this.menuOptions[key] = false;
    });
  }

  async logout() {
    localStorage.clear();
    sessionStorage.clear();

    this.cookieService.deleteAll('/');
    this.cookieService.deleteAll();
    this.authService.instance.clearCache();

    // TODO: logout should be done using MSAL library. Because it did not work, this is implemented using a more static approach.
    // should be replaced my MSAL.
    const logoutUrl = `${b2cPolicies.authorities.signOut.authority}?post_logout_redirect_uri=${encodeURIComponent(window.location.origin)}`;
    window.location.href = logoutUrl;
  };

}
